import axios from "axios";

export default axios.create({
  baseURL: import.meta.env.VITE_QBI_API_URL as string,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
  withCredentials: true,
});
